import {EntryRowTypeHelpers} from 'common/query-builder/query-entry-section/row-types/types';
import {QuerySavedMetricEntry} from 'common/query-builder/query-entry-section/types';

// eslint-disable-next-line import/no-cycle
import {SavedMetricEntryRow} from './index';

export const helpers: EntryRowTypeHelpers<QuerySavedMetricEntry> = {
  component: SavedMetricEntryRow,
};
